import React from 'react'
import classNames from 'classnames'

import { ImgSanity } from '@slite/components'

import { Section } from '../../components/Section'
import { WebsiteText } from '../../components/WebsiteText'

export const SectionGridBenefits = ({
  title,
  data,
  mainColor = 'saturn-orange',
  background,
}: {
  title: React.ReactNode
  mainColor?: string
  background?: string
  data: {
    title: string
    description: string
    imageClassnames?: string
    imageUrl: string
    imageAlt: string
  }[]
}) => {
  return (
    <Section background={background}>
      <div className="grid-12">
        <div className="grid-span-10 grid-offset-1 text-align-center margin-bottom-48">
          <WebsiteText variant="title" className="margin-bottom-40">
            {title}
          </WebsiteText>
        </div>
      </div>
      <div className="grid-12 grid-gap-40">
        {data.map((d, index) => (
          <div
            key={d.title}
            className={classNames(
              'radius-large padding-top-32 flexbox flexbox-column overflow-hidden grid-span-12-medium grid-span-12-small',
              [0, 3].includes(index) ? 'grid-span-7' : 'grid-span-5',
              index === data.length - 1
                ? `background-${mainColor} white`
                : 'background-moon-dust'
            )}
          >
            <h4 className="font-family-title font-weight-medium margin-bottom-8 font-size-4 padding-horizontal-24">
              {d.title}
            </h4>
            <WebsiteText
              variant="body"
              className="padding-bottom-24 padding-horizontal-24 flexbox-grow"
            >
              {d.description}
            </WebsiteText>

            <div className={d.imageClassnames}>
              <ImgSanity alt={d.imageAlt} src={d.imageUrl} className="block" />
            </div>
          </div>
        ))}
      </div>
    </Section>
  )
}
